import React, {useEffect, useState} from 'react';
import axios from 'axios';
import UploadFile from '../components/UploadFile';
import Loading from '../components/Loading';
import ReactMarkdown from 'react-markdown';
import ChatBot from '../components/ChatBot';

export default function PathologicalPage({setPage}){
    const [data, setData] = useState({}); //data is for saving data from flask(title, url...)
    const [uploadedFiles, setUploadedFiles] = useState([]);    
    const [errorMsg, setErrorMsg] = useState('');
    const [paragraph, setParagraph] = useState('');
    const [chain, setChain] = useState([]);
    const [loading, setLoading] = useState(false);
    const [resultimg, setResultimg] = useState([]);

    useEffect(()=>{
        axios.get("/api/pathologicpage") //<->methods["GET"]
        .then(res=>setData(res.data)); //setData->get res.data than save to state
    },[]); //[]-> only execute once (like the default state here)

    // clear the previous folder for tmp upload file 
    useEffect(() => {
    (async () => {
        try {
        const r = await fetch('/api/clear_uploads', { method: 'POST' });
        const j = await r.json();
        console.log('clear_uploads:', j);
        } catch (e) {
        console.error('clear_uploads failed:', e);
        }
    })();
    }, []);

    // Handling upload function
    const handleUpload = async (files, tag) => {
        if (!files || files.length === 0) {
        console.warn("沒有檔案被選取");
        return;
        }
        setUploadedFiles(files);
        console.log("Uploading...");
        const formData = new FormData();
        files.forEach(f => formData.append('file', f));
        // const ext = files[0].name.split('.').pop().toLowerCase();
        formData.append('type', tag);
      
        const res = await axios.post('/api/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log("上傳成功", res.data);
    };
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // Start analysis
    const startAnalysis = async () => {
        try {
          const res1 = await axios.post('/api/return_txt', {
            page: 'patho' }
         );
      
        //   const res2 = await axios.get('/api/get_chain', {
        //     params: { page: 'patho' }
        //   });
      
          return {
            paragraph: res1.data.paragraph,
            //chain: res2.data.chain
          };
        } catch (err) {
          console.error('分析錯誤:', err);
          return null;
        }
    };

    const handleDemoUpload = async () => {
        setLoading(true);
        setErrorMsg("");

        try {
            const demoTypes = "patho_report"

            const formData = new FormData();
            formData.append("type", demoTypes);
            formData.append("demo", "true");

            await axios.post("/api/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            

            setUploadedFiles(["demo"]);
            console.log("✅ Demo files loaded");

            await handleAll();

        } catch (err) {
            console.error("Demo upload error:", err);
            setErrorMsg("Demo files loading failed.");
        } finally {
            setLoading(false);
        }
    };
    
    const startPickModel = async () => {
        return axios.post('/api/pick_model', {params:{text:paragraph}})
        .then(res => setResultimg(res.data))
        .catch(err => {
            console.error('錯誤', err);
        })
    };
    const handleAll = async () => {
        setLoading(true);
        try {
            const result = await startAnalysis();
            //await startPickModel();
            if (result) {
                setParagraph(result.paragraph);
                //setChain(result.chain);
            }
        } catch (err){
            console.error('error:', err)
        } finally {
            setLoading(false);
        }
    };


    return(
        <div style={{backgroundColor: '#f9f7f2',}}>
            <div style={{textAlign:'center', display:'flex', 
                        alignItems:'center', marginLeft:'60px'}}>
                <button onClick={() => setPage('home')} 
                style={{...styles.page_button, backgroundColor: '#84D9AD'}}>
                Home Page
                </button>
                <button onClick={() => setPage('cohort')} 
                style={{...styles.page_button, backgroundColor: '#ACABDD'}}>
                Cohort Analysis
                </button>
                <button onClick={() => setPage('multicase')} 
                style={{...styles.page_button, backgroundColor: '#6e8f9f'}}>
                Multi-report Analysis
                </button>
            </div>
            <div style={{ textAlign: 'center', padding: '40px', 
                            display:'flex', gap:'30px', alignItems:'center'}}>
                {/* LOGO */}
                {data.logo_url &&(<img src={data.logo_url} alt="logo" style={{
                            width:'180px', marginBottom:'20px', marginLeft:'50px',
                            filter: 'contrast(90%) brightness(95%) hue-rotate(30deg)'
                        }}/>)}
                
                {/* TITLE */}
                <h1 style={{ color: "#86B6DD", fontSize: '3.5rem', 
                            fontFamily: `"Microsoft JhengHei", "Noto Sans TC", sans-serif`}}>
                    {data.title}</h1>
            </div>
            {/* UPLOAD AREA*/}
            <div style={{textAlign:'center', display:'flex', 
                        alignItems:'center', marginLeft:'200px'}}>
                <UploadFile onUpload={(files)=>handleUpload(files, 'patho_report')} 
                            accept={['.pdf', '.txt', '.json']}
                            multiple={false}
                            style={{...styles.upload_area,
                                    backgroundColor:'#8CD4D9',
                                    color:'#f9f7f2'}}
                            title={'Upload Pathology Report'}
                            subtitle={'Support single pdf/json/txt file'}/>
                {/* <UploadFile onUpload={(files)=>handleUpload(files, 'patho_clinical')} 
                            accept={['.pdf', '.txt', '.json']}
                            multiple={false}
                            style={{...styles.upload_area,
                                    backgroundColor:'#86B6DD',
                                    color:'#f9f7f2'}}
                            title={'Upload Clinical Data'}
                            subtitle={'Support single pdf/json/txt file'}/>
                <UploadFile onUpload={(files)=>handleUpload(files, 'patho_bio')} 
                            accept={['.pdf', '.txt', '.json']}
                            multiple={false}
                            style={{...styles.upload_area,
                                    backgroundColor:'#ACABDD',
                                    color:'#f9f7f2'}}
                            title={'Upload Biospecimen Results'}
                            subtitle={'Support single pdf/json/txt file'}/> */}

            </div>
            {/* START BUTTON */}
            <div>
                <button
                    onClick={handleDemoUpload}
                    style={{...styles.demo_button}}
                >
                    Use Demo
                </button>
                <button onClick={async () => {
                        if (!uploadedFiles || uploadedFiles.length === 0) {
                            setErrorMsg("Please at least upload a file.")
                        return;
                        }
                        setErrorMsg("")
                        console.log("準備分析：", uploadedFiles);
                        // await sleep(3000);
                        handleAll();
                    }}
                    style={{...styles.start_button}}>
                {loading ? "Analyzing":"Start Analysis"}</button>
                <div className="relative min-h-screen">
                    {loading && <Loading />}
                </div>
                {errorMsg && (
                <div style={styles.error_msg}>
                    {errorMsg}
                </div>
                )}

            </div>
            {paragraph && (<div style={styles.txt_area}>
                <ReactMarkdown>{paragraph}</ReactMarkdown>
            </div>)}
            <div>
                {paragraph && (<div>
                    <ChatBot></ChatBot>
                </div>)}
            </div>


        </div>
    )

}

const styles={
    page_button: {
        padding: '12px 26px',
        borderRadius: '8px',
        backgroundColor: '#86B6DD',
        fontWeight: '600',
        cursor: 'pointer',
        marginTop: '20px',
        fontSize: '16px',
        marginLeft:'1px',
        border:'0px',
        color:'#f9f7f2'
      },
    upload_area:{
    },
    start_button:{
        borderRadius: '32px',
        padding: '15px',
        width: '100%',
        maxWidth: '400px',
        cursor: 'pointer',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        fontFamily: 'Noto Sans TC, sans-serif',
        marginLeft: '200px',
        marginTop: '30px',
        backgroundColor: '#CECED9',
        color:'#202143',
        fontSize:'1.2rem',
        fontWeight: '700',
        border:'none'
    },
    error_msg:{
        color: 'red',
        marginTop: '10px',
        fontWeight: 'bold',
        backgroundColor: '#ffe0e0',
        padding: '8px 12px',
        borderRadius: '8px'
    },
    txt_area:{
        border: '5px solid #ccc',
        padding: '20px',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        maxHeight: '600px',
        maxWidth: '1200px',
        overflowY: 'auto',
        fontSize: '16px',
        lineHeight: '1.6',
        marginLeft: '180px',
        marginTop: '50px',
        marginBottom: '100px'
    },
    demo_button: {
        borderRadius: '32px',
        padding: '15px',
        width: '100%',
        maxWidth: '400px',
        cursor: 'pointer',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        fontFamily: 'Noto Sans TC, sans-serif',
        marginLeft: '200px',
        marginTop: '30px',
        backgroundColor: '#84D9AD',
        color:'#202143',
        fontSize:'1.2rem',
        fontWeight: '700',
        border:'none'
    },
}